import { PluralTranslatePipe, Vehicle } from '@agilox/common';
import { CustomDatePipe } from '@agilox/pipe/custom-date';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getEarliestSubscriptionEnd } from '../utils/earliest-subscription-end.util';
import { buildSubscriptionVehicleList } from '../utils/subscription-vehicle-list.util';

const CONJUNCTION_KEY = 'general.and';
const MISSING_DATE = '-';

@Pipe({
	name: 'subscriptionNotifyTranslation',
})
export class SubscriptionNotifyTranslationPipe implements PipeTransform {
	private translate = inject(TranslateService);
	private customDatePipe = inject(CustomDatePipe);

	transform(vehicles: Vehicle[], singularTranslation: string, pluralTranslation: string): string {
		if (!vehicles || vehicles.length === 0) {
			return '';
		}

		const vehicleList = buildSubscriptionVehicleList(
			vehicles,
			this.translate.instant(CONJUNCTION_KEY)
		);
		const earliestSubscriptionEnd = getEarliestSubscriptionEnd(vehicles);

		return new PluralTranslatePipe(this.translate).transform(
			vehicles.length,
			singularTranslation,
			pluralTranslation,
			{
				vehicles: vehicleList,
				date: this.customDatePipe.transform(earliestSubscriptionEnd) ?? MISSING_DATE,
			}
		);
	}
}
